<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
       <div class="text-center">
        <div class="card-custom-web">
            <img
            v-if="studentProfileAuthorize == ''"
            class="mt-5 custom-image-user"
            src="../assets/img/icon/icondefault.svg"
          />
          <img
            v-else
            class="mt-5 custom-image-user"
            :src="photoURL"
            style="border-radius: 50%; border: 5px solid #fff"
          />
            <h3 class="title-user-done mt-4"> {{ user.name }}</h3>
            <h4 class="sub-title-header-done">
               {{ user.name }} student account has <br />
               been created!
            </h4>
             <span class="custom-sub-grade-sucess text-center"> {{ Grade }}</span>
        </div>
        <br />  <br />  <br />
        </div>
      </div>
     
    </CContainer>
    <div class="bottom-center">
      <CButton color="info" class="custom-btn-login-active mt-5" @click="GoToHomepage()"> Go To Homepage</CButton>
      <br />
        <label class="mt-3 custom-label-note">
       <span class="text-inline text-blue" @click="GoToRegister()">Add Another Student</span> </label>
    </div>
   
    <div class="header-top">Register Student</div>
    <div class="header-left">
      <img src="../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
import _ from "lodash";
export default {
  data: function () {
    return {
      user: {},
      subject: [],
      FilterSubject: [],
      Grade: this.$route.query.Grade,
      Exam: this.$route.query.Exam,
      SearchQuery: "",
      SelectedSubject: "",

      studentProfileAuthorize: "",
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
             this.GetAuthorizeProfile(this.user.id);
          }
        });
    },
      GetAuthorizeProfile() {
      this.$API
        .get(this.$GetProfilePhotoAuthorize + "?userId=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.studentProfileAuthorize = response.data;
            this.photoURL =
              "https://pickiddo.com" + this.studentProfileAuthorize;
          }
        });
    },
    GoBack() {
      this.$router.back();
    },
    GoToHomepage()
    {
       this.$router.push(
        "/ExistingUser"
      );
    },
    GoToRegister()
    {
       this.$router.push(
        "/RegisterStudentGrade"
      );
    }
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #DBDBDB;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #E0E0E0;;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #E0E0E0;;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

</style>